module.exports = require("@swa-ui/core/src/HorizontalGestureScroller/HorizontalGestureScroller.module.scss");